import React from "react";
import { Column } from "@ant-design/charts";
import { Skeleton } from "@pankod/refine-antd";
import { useCustom } from "@pankod/refine-core";
import ENV from "utils/env";
import { extractPaginated } from "../utils";

type RawShop = { shopCode: string; totalEvents: string };

interface TopShopsColumnProps {
  dateRange: [string, string];
  shopCode: string | null;
}

export const TopShopsColumn: React.FC<TopShopsColumnProps> = ({
  dateRange,
  shopCode,
}) => {
  const { data: response, isFetching } = useCustom({
    url: `${ENV.API_URL}/api/analytics/stats/top-shops`,
    method: "get",
    config: {
      query: {
        startDate: dateRange[0],
        endDate: dateRange[1],
        page: 1,
        limit: 25,
        ...(shopCode ? { shopCode } : {}),
      },
    },
    queryOptions: { retry: 0 },
  });

  if (isFetching) return <Skeleton active />;

  const { items } = extractPaginated<RawShop>(response?.data);
  const data = items.slice(0, 20).map((r) => ({
    shop: r.shopCode,
    count: parseInt(r.totalEvents, 10),
  }));

  if (data.length === 0) {
    return (
      <span style={{ color: "#8c8c8c" }}>Bu filtrelere ait veri bulunamadı.</span>
    );
  }

  const config = {
    data,
    xField: "shop",
    yField: "count",
    color: "#448ab7",
    style: {
      maxWidth: 40,
    },
    label: {
      text: (d: any) => String(d.count),
      position: "inside" as const,
      style: { fill: "#fff", fontWeight: 600 },
    },
    axis: {
      x: {
        labelAutoRotate: true,
      },
    },
  };

  return <Column {...config} />;
};
